function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "13.188"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_2000",
  "data-name": "Rectangle 2000",
  fill: "none",
  d: "M0 0h17v18H0z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_4760",
  "data-name": "Group 4760"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4759",
  "data-name": "Group 4759",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2553",
  "data-name": "Path 2553",
  d: "M16.972.407a.5.5 0 00-.008-.095c-.007-.016-.025-.024-.033-.04a.457.457 0 00-.09-.111.462.462 0 00-.108-.09c-.015-.008-.022-.025-.038-.031a.489.489 0 00-.1-.012C16.561.022 16.534 0 16.5 0H3.507a.5.5 0 00-.358.151l-3 3.08v.006a.5.5 0 00-.114.218.467.467 0 00-.013.065.375.375 0 00-.022.066v9.1a.5.5 0 00.5.5h12.8a.552.552 0 00.081-.016.543.543 0 00.105-.021.487.487 0 00.112-.072.346.346 0 00.045-.029l.006-.005.007-.006 3.187-3.009A.5.5 0 0017 9.666V.5c0-.034-.022-.061-.028-.093M3.718 1h11.543L13.1 3.086H1.685zM1 4.086h11.8v8.1H1zm12.8 7.441V3.8L16 1.677V9.45z",
  fill: "#282828"
})))));